





























import { defineComponent, ref } from '@vue/composition-api';

const name = 'ttam-creative-no-identity-info-alert';

export default defineComponent({
  name,
  setup() {
    const curMoreActive = ref(false);
    return {
      name,
      curMoreActive,
    };
  },
});
